<div class="batch-management">

  <!-- バッチ稼働状況 -->
  <div class="batch-section batch-operation-status">
    <div class="section-header">
      <h3>バッチ稼働状況</h3>
    </div>

    <!-- 条件設定エリア -->
    <div class="condition-area">
      <div class="condition-row">
        <div class="condition-group">
          <label>バッチ稼働状況日:</label>
          <select [(ngModel)]="selectedDate" (ngModelChange)="onDateChange()" class="date-select">
            <option *ngFor="let date of dateOptions" [value]="date">
              {{ getDisplayDate(date) }}
            </option>
          </select>
        </div>

        <div class="condition-group">
          <label>種類:</label>
          <div class="radio-group">
            <label class="radio-label">
              <input type="radio" name="resultType" value="all"
                [(ngModel)]="selectedResultType" (ngModelChange)="onResultTypeChange()">
              <span>すべて</span>
            </label>
            <label class="radio-label">
              <input type="radio" name="resultType" value="success"
                [(ngModel)]="selectedResultType" (ngModelChange)="onResultTypeChange()">
              <span>成功</span>
            </label>
            <label class="radio-label">
              <input type="radio" name="resultType" value="failure"
                [(ngModel)]="selectedResultType" (ngModelChange)="onResultTypeChange()">
              <span>失敗</span>
            </label>
          </div>
        </div>

        <div class="button-group form-actions">
          <button type="button" class="btn btn-primary btn-sm" (click)="onRefreshClick()"
            [disabled]="isLoading">
            再抽出
          </button>
        </div>
      </div>
    </div>

    <!-- データテーブル -->
    <div class="table-container">
      <div *ngIf="isLoading" class="loading-indicator">
        データを読み込んでいます...
      </div>

      <table *ngIf="!isLoading" class="data-table batch-log-table">
        <thead>
          <tr>
            <th class="col-batch-name">バッチ名</th>
            <th class="col-last-run-time">最終実行日時</th>
            <th class="col-result">結果</th>
            <th class="col-message">メッセージ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of batchExecutionLogs" class="data-row">
            <td class="col-batch-name">{{ log.jobName }}</td>
            <td class="col-last-run-time">{{ log.lastRunAt }}</td>
            <td class="col-result" [class.result-success]="log.result === '成功'"
              [class.result-failure]="log.result === '失敗'">
              {{ log.result }}
            </td>
            <td class="col-message">{{ log.lastError }}</td>
          </tr>
          <tr *ngIf="batchExecutionLogs.length === 0" class="no-data-row">
            <td colspan="4" class="no-data-message">該当するデータがありません</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- バッチ手動実行 -->
  <div class="batch-section batch-manual-execution">
    <div class="section-header">
      <h3>バッチ手動実行</h3>
    </div>
    <div class="manual-execution-content">
      <div class="execution-controls">
        <div class="control-group">
          <label>バッチ選択:</label>
          <select class="form-select batch-select" [(ngModel)]="selectedBatchName">
            <option value="">-- バッチを選択してください --</option>
            <option *ngFor="let batch of manualBatchList" [value]="batch.batchName">
              {{ batch.jobName }}
            </option>
          </select>
        </div>
        <div class="button-group form-actions">
          <button type="button" class="btn btn-danger btn-sm"
            (click)="onManualExecuteClick()"
            [disabled]="!selectedBatchName || isManualExecuting">
            {{ isManualExecuting ? '実行中...' : '手動実行' }}
          </button>
        </div>
      </div>
      <div class="execution-status" *ngIf="manualExecutionMessage">
        <p class="status-message"
          [class.text-success]="manualExecutionSuccess === true"
          [class.text-danger]="manualExecutionSuccess === false">
          {{ manualExecutionMessage }}
        </p>
      </div>
    </div>
  </div>

  <!-- 下段の2つのブロック -->
  <div class="bottom-sections">
    <!-- DTJExport処理状況 -->
    <div class="batch-section dtj-export-status">
      <div class="section-header">
        <h3>DTJExport処理状況</h3>
      </div>

      <!-- 条件設定エリア -->
      <div class="condition-area">
        <div class="condition-row">
          <div class="condition-group">
            <label>DTJExport処理状況日:</label>
            <select [(ngModel)]="dtjSelectedDate" (ngModelChange)="onDTJDateChange()"
              class="date-select">
              <option *ngFor="let date of dtjDateOptions" [value]="date">
                {{ getDisplayDate(date) }}
              </option>
            </select>
          </div>

          <div class="button-group form-actions">
            <button type="button" class="btn btn-primary btn-sm" (click)="onDTJRefreshClick()"
              [disabled]="dtjIsLoading">
              再抽出
            </button>
          </div>
        </div>
      </div>

      <!-- DTJExportテーブル -->
      <div class="table-container">
        <div *ngIf="dtjIsLoading" class="loading-indicator">
          データを読み込んでいます...
        </div>

        <table *ngIf="!dtjIsLoading" class="data-table dtj-log-table">
          <thead>
            <tr>
              <th class="col-finished-time">終了日時</th>
              <th class="col-result">結果</th>
              <th class="col-count">成功数</th>
              <th class="col-count">失敗数</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let log of dtjExecutionLogs" class="data-row">
              <td class="col-finished-time">{{ log.finishedAt }}</td>
              <td class="col-result" [class.result-success]="log.result === '成功'"
                [class.result-failure]="log.result === '失敗'">
                {{ log.result }}
              </td>
              <td class="col-count">{{ log.successCount }}</td>
              <td class="col-count">{{ log.failedCount }}</td>
            </tr>
            <tr *ngIf="dtjExecutionLogs.length === 0" class="no-data-row">
              <td colspan="4" class="no-data-message">該当するデータがありません</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- TSReminder処理状況 -->
    <div class="batch-section tsr-export-status">
      <div class="section-header">
        <h3>TSReminder処理状況<span class="subtitle">（過去2か月間、1件以上）</span></h3>
      </div>

      <!-- TSReminderテーブル -->
      <div class="table-container">
        <div *ngIf="tsrIsLoading" class="loading-indicator">
          データを読み込んでいます...
        </div>

        <table *ngIf="!tsrIsLoading" class="data-table tsr-log-table">
          <thead>
            <tr>
              <th class="col-sent-time">送信日時</th>
              <th class="col-result">結果</th>
              <th class="col-count">ASCへの送信数</th>
              <th class="col-count">承認者への送信数</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let log of tsrExecutionLogs" class="data-row">
              <td class="col-sent-time">{{ log.finishedAt }}</td>
              <td class="col-result" [class.result-success]="log.result === '成功'"
                [class.result-failure]="log.result === '失敗'">
                {{ log.result }}
              </td>
              <td class="col-count">{{ log.ascCount }}</td>
              <td class="col-count">{{ log.apvCount }}</td>
            </tr>
            <tr *ngIf="tsrExecutionLogs.length === 0" class="no-data-row">
              <td colspan="4" class="no-data-message">該当するデータがありません</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</div>
